<template>
    <div v-if="loading">
        <b-row>
            <b-col md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-4"
                />
            </b-col>
        </b-row>
    </div>
    <div v-else>
        <b-row>
            <b-col>
                <h3>Service Request</h3>
            </b-col>
            <b-col>
                <b-button
                    style="float: right"
                    class="mt-1"
                    @click="
                        $router.push({
                            name: 'Customer-Management-Listing',
                            params: {
                                id: $route.params.customerId,
                            },
                        })
                    "
                    variant="primary"
                    >Back
                </b-button>
            </b-col>
            <!-- <b-col
        ><b-button
          v-if="details && details.status === 'CLOSE'"
          variant="outline-primary"
          style="margin-left: 55px"
          >REOPEN SERVICE REQUEST</b-button
        >
        <b-button
          style="float: right"
          variant="primary"
          @click="$router.push({ name: 'raise-service-request' })"
        >
          <i class="fa fa-plus" aria-hidden="true"></i> New Service
          Request</b-button
        >
      </b-col> -->
        </b-row>
        <b-card class="mt-3">
            <b-row align-h="between">
                <b-col cols="6">
                    <h4 class="text-secondary mb-1 mt-0">
                        Request Id : #{{ details.ticketNo }}
                    </h4>
                </b-col>
                <b-col cols="2">
                    <b-button
                        variant="success"
                        class="ml-5 mb-1 mt-0"
                        v-if="details.status === 'OPEN'"
                        >{{ details.status }}</b-button
                    >
                    <b-button variant="danger" class="ml-5 mb-1 mt-0" v-else>{{
                        details.status
                    }}</b-button>
                </b-col>
            </b-row>

            <b-row class="mt-2">
                <b-col>
                    <div :key="k" v-for="(category, k) in categoryList">
                        <h5
                            class="text-secondary mb-1 mt-0"
                            v-if="details && details.category === category._id"
                        >
                            Category : {{ category.name }}
                        </h5>
                    </div>
                </b-col>
                <b-col>
                    <h5 class="text-secondary mb-1 mt-0">
                        Created By :
                        {{
                            details && details.reportedBy
                                ? details.reportedBy.name
                                : ""
                        }}
                    </h5>
                </b-col>
                <b-col>
                    <h5 class="text-secondary mb-1 mt-0">
                        Assign To :
                        {{
                            details && details.assignTo
                                ? details.assignTo.name
                                : ""
                        }}
                    </h5>
                </b-col>
                <b-col>
                    <h5 class="text-secondary mb-1 mt-0">Severity : Low</h5>
                </b-col>
                <b-col>
                    <h5 class="text-secondary mb-1 mt-0">
                        Created Date : {{ details.createdAt | formatedate }}
                    </h5>
                </b-col>
            </b-row>

            <b-row align-h="between">
                <b-col cols="6">
                    <h4 class="text-secondary mb-1 mt-0">
                        Description : {{ details.description }}
                    </h4>
                </b-col>
            </b-row>
        </b-card>

        <div v-if="details && details.status === 'OPEN'">
            <h3>Update Status</h3>
            <b-card>
                <!-- <b-row
          ><b-col md="6"
            ><h4 class="text-primary">
              FIRST RESPONSE DUE : <br />
              By Wed, 06 Jul 2022, 9:00 PM
            </h4></b-col
          ><b-col md="6"
            ><h4 class="text-primary">
              RESOLUTION DUE : <br />
              By Wed, 06 Jul 2022, 9:00 PM
            </h4>
            <b-button variant="primary" class="edit-btn">Edit</b-button>
          </b-col>
        </b-row> -->
                <b-row
                    ><b-col>
                        <label for="status">Update Status</label>
                        <eb-select
                            :label="'text'"
                            v-model="status"
                            :options="statusOptions"
                            :id="status"
                            placeholder="Select Status"
                        >
                        </eb-select
                    ></b-col>
                    <b-col>
                        <label for="severity">Severity</label>
                        <eb-select
                            :label="'text'"
                            :id="severity"
                            v-model="severity"
                            :options="severityOptions"
                            placeholder="Select Severity"
                        >
                        </eb-select> </b-col
                ></b-row>
                <!-- <b-row
          ><b-col>
            <label for="department">Department</label>
            <eb-select
              :label="'name'"
              :id="department"
              placeholder="Biling/Customer Support/Escalations"
            >
            </eb-select> </b-col
          ><b-col>
            <label for="agent">Select Agent</label>
            <eb-select :label="'name'" :id="agent" placeholder="Agent Names">
            </eb-select> </b-col
        ></b-row> -->
                <b-row
                    ><b-col
                        ><h4>Comment</h4>
                        <textarea
                            class="myDIV"
                            rows="5"
                            cols="120"
                            style="border: 1px solid black"
                            id="description"
                            inputType="text"
                            maxlength="300"
                            v-model="details.description"
                        /></b-col
                ></b-row>
                <div class="mt-5">
                    <b-button
                        variant="primary"
                        class="update-btn font-weight-bolder"
                        @click="updateTicketData"
                        >UPDATE</b-button
                    >
                </div>
            </b-card>
        </div>
        <div>
            <h3 class="my-3">Service Request Update history</h3>
            <b-table
                :striped="true"
                :bordered="true"
                hover
                :fields="title"
                thead-class="header"
                :items="history"
                @filtered="onFilter"
                :current-page="currentPage"
                :per-page="perPage"
            >
                <template slot="cell(updatedAt)" slot-scope="data">
                    <div>{{ data.item.updatedAt | formatedate }}</div>
                </template>
            </b-table>
            <div style="float: right">
                <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="filterCount"
                    aria-controls="my-table"
                    prev-text="Prev"
                    next-text="Next"
                    hide-goto-end-buttons
                ></b-pagination>
            </div>
        </div>
        <div class="mt-5" v-if="attachments.length > 0">
            <h3 class="mt-3">Attachments</h3>
            <b-row class="card my-3">
                <b-col md="4" v-for="(item, i) in attachments" :key="i">
                    <a
                        :href="`https://${item
                            .replace('http://', '')
                            .replace('https://', '')}`"
                        class="text-dark"
                        target="_blank"
                    >
                        <b-button variant="primary"
                            >Download Attachment</b-button
                        >
                    </a>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { AtomSpinner } from "epic-spinners";
import ebSelect from "@/components/FormElements/Select.vue";
export default {
    components: {
        ebSelect,
        AtomSpinner,
    },
    data() {
        return {
            severityOptions: [
                { text: "Low", value: "Low" },
                { text: "Medium", value: "Medium" },
                { text: "High", value: "High" },
                { text: "Critical", value: "Critical" },
            ],
            statusOptions: [
                { text: "OPEN", value: "OPEN" },
                { text: "CLOSED", value: "CLOSED" },
            ],
            title: [
                { key: "action", label: "Action" },
                { key: "updatedBy.name", label: "Update By" },
                { key: "updatedAt", label: "Date" },
                { key: "description" },
            ],
            details: "",
            loading: false,
            severity: "",
            status: "",
            history: [],
            comment: "",
            currentPage: 1,
            perPage: 5,
            filterCount: 0,
            attachments: [],
        };
    },

    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY hh:mm:ss");
            }
        },
    },

    computed: {
        categoryList() {
            let data =
                this.$store.getters["servicerequest/GetServiceRequestList"];
            let list = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    let arrayObj = {
                        name: obj.name,
                        _id: obj._id,
                    };
                    list.push(arrayObj);
                });
                return list;
            } else {
                this.loading = false;
                return [];
            }
        },
    },

    methods: {
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },

        async fetchServiceRequestDetails() {
            const payload = {
                id: this.$route.params.id,
                tenant: this.$currentUserData._id,
            };
            const data = await this.$store.dispatch(
                "customerManagement/serviceTicketDetail",
                payload,
            );
            this.details = data.data.data;
            this.history = this.details.changeHistory;
            this.attachments = this.details.attachments
                .map((a) => a.url)
                .filter((x) => typeof x === "string" && x.length);
            return this.details;
        },

        async fetchCategoryList() {
            return await this.$store.dispatch(
                "servicerequest/fetchServicerequestList",
            );
        },

        async updateTicketData() {
            this.loading = true;
            let tenantInfo = JSON.parse(sessionStorage.getItem("userLogin"));
            const payload = {
                id: this.details._id,
                data: {
                    assignTo: {
                        id: this.details.assignTo.id,
                        name: this.details.assignTo.name,
                        email: this.details.assignTo.email,
                        userType: this.details.assignTo.userType,
                        phone: this.details.assignTo.phone,
                    },
                    reportedTo: {
                        id: this.details.reportedTo.id,
                        name: this.details.reportedTo.name,
                        email: this.details.reportedTo.email,
                        userType: this.details.reportedTo.userType,
                        phone: this.details.reportedTo.phone,
                    },
                    reportedBy: {
                        id: this.$currentUserData._id,
                        name: this.$currentUserData.userName,
                        email: this.$currentUserData.email,
                        userType: "TENANT",
                        phone: this.$currentUserData.phone,
                    },
                    status: this.status.value,
                    _id: this.details._id,
                    category: this.details.category,
                    description: this.details.description,
                    subject: this.details.subject,
                    severity: this.severity.value,
                    attachments: this.details.attachments,
                    ticketNo: this.details.ticketNo,
                    tenant: this.details.tenant,
                    scope: this.details.scope,
                    worknoteHistory: [
                        {
                            updatedBy: {
                                id: this.$currentUserData._id,
                                name: `${this.$currentUserData.first} ${this.$currentUserData.last}`,
                                email: this.$currentUserData.email,
                                userType: this.$currentUserData.category,
                                phone: this.$currentUserData.phone,
                            },
                            updatedAt: this.details.updatedAt,
                            _id: this.details._id,
                            description: this.details.description,
                        },
                    ],
                    changeHistory: this.details.changeHistory,
                    internalComments: this.details.internalComments,
                    updatedBy: {
                        name: tenantInfo.userName,
                        email: tenantInfo.email,
                        phone: tenantInfo.phone,
                    },
                    createdAt: this.details.createdAt,
                    updatedAt: this.details.updatedAt,
                },
            };

            await this.$store
                .dispatch("serviceticket/updateServiceTicketAction", payload)
                .then((payload) => {
                    this.$swal({
                        title: "Success",
                        text: "Incident Updated successfully!!",
                        type: "success",
                    });
                    this.fetchServiceRequestDetails();
                    this.loading = false;
                })
                .catch((err) => {
                    this.$swal({
                        title: "Opps!!!!!",
                        text: "Error!!!",
                        type: "error",
                    });
                });
            this.loading = false;
        },
    },

    async mounted() {
        this.loading = true;
        await this.fetchServiceRequestDetails();
        await this.fetchCategoryList();
        this.loading = false;
    },
};
</script>

<style scoped>
.edit-btn {
    border-radius: 14px;
    float: right;
    margin-top: -49px;
}
.update-btn {
    float: right;
    width: 15%;
}
</style>
